import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

import { toastError } from '@components/Toast';

import AddMeasurementSize from '@features/measurement/components/AddMeasurementSize';
import PomCardView from '@features/pom/components/PomCardView';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { fetchPomList, loadLibraryPOMFromMainCategory } from '@services/pomService';

import { checkUserType, groupByKey } from '@utils/Util';

const AddPomFromRightPnael = ({
	pomTemplateDetails,
	onClose,
	selectedPomIds,
	onCheckBoxClick,
	fromPage,
	onLoadPomTemplateClick,
	isEditable,
	onAddSuccess
}) => {
	const [page, setPage] = useState(0);
	const [allPomList, setAllPomList] = useState(null);
	const [sort, setSort] = useState('bodyPart');
	const [search, setSearch] = useState('');
	const dispatch = useDispatch();
	const scrollRef = useRef({});
	const requestRef = useRef(null);

	useEffect(() => {
		onFetchPomList();
	}, [sort, page, search]);

	const onFetchPomList = async () => {
		if (requestRef.current) {
			requestRef.current.cancel();
		}

		const source = axios.CancelToken.source();
		requestRef.current = source;

		try {
			dispatch(openLoader());
			let query = `page=${page}&sort=${sort}&size=20`;
			if (search) query += `&search=${encodeURIComponent(search)}`;
			query += `&inProductMeasurementPage=${fromPage === 'MEASUREMENT' ? true : false}`;

			const data = await fetchPomList(query, source.token);

			if (requestRef.current === source) {
				if (data.currentPage > 0) {
					data.data = [...(allPomList?.data || []), ...data.data];
				}
				setAllPomList(data);
			}

			dispatch(closeLoader());
		} catch (error) {
			if (axios.isCancel(error)) {
				toastError(error.message);
			} else {
				dispatch(closeLoader());
			}
		}
	};

	useEffect(() => {
		return () => {
			if (requestRef.current) {
				requestRef.current.cancel();
			}
		};
	}, []);

	const handleScroll = (e) => {
		let { totalElements, currentPage, data } = allPomList;
		const threshold = 5;
		let isReachBottom = e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight + threshold;
		if (isReachBottom) {
			if (totalElements !== data?.length) {
				setPage(() => currentPage + 1);
			}
		}
	};

	const renderPomList = () => {
		let groupedProducts = groupByKey(allPomList?.data, `${sort}.name`);
		return Object.keys(groupedProducts)?.map((key) => {
			let products = groupedProducts[key];
			return (
				<div className="compair-table pt-3" key={`group_products_${key}`}>
					<h3 className="table-title gray_dark_01 weight-600 regular-14">
						{key} ({products?.length})
					</h3>
					<PomCardView
						onCheckBoxClick={onCheckBoxClick}
						selectedPomIds={selectedPomIds}
						isCheckBox={true}
						pomList={products}
						fromPage={fromPage}
						onDeletePomFromList={() => {}}
						selectedBrand={() => {}}
					/>
				</div>
			);
		});
	};

	const onLoadClick = async () => {
		try {
			dispatch(openLoader());
			const data = await loadLibraryPOMFromMainCategory(
				pomTemplateDetails?.id,
				pomTemplateDetails?.subCategoryResponse?.id
			);
			if (onAddSuccess) {
				onAddSuccess(data);
			}
			onClose();
			dispatch(closeLoader());
		} catch (error) {
			dispatch(closeLoader());
			toastError(error.message);
		}
	};

	return (
		<div
			className={`${
				fromPage === 'MEASUREMENT'
					? 'pom-measurement-sidebar fixed-height'
					: 'pom-measurement-sidebar'
			}`}
		>
			<div className="pom-measurement-header">
				<div className="d-flex align-items-center justify-content-between mb-3">
					<div></div>
					<img
						onClick={onClose}
						src={`${process.env.PUBLIC_URL}/icons/close.svg`}
						alt="close"
						className="cursor-pointer"
					/>
				</div>

				{fromPage === 'MEASUREMENT' && (
					<AddMeasurementSize
						onCheckBoxClick={onCheckBoxClick}
						selectedPomIds={selectedPomIds}
						isEditable={isEditable}
					/>
				)}

				<div className="measurement-size-search">
					<div className="m-0 search-filter">
						<div className="with-icon">
							<span className="left-icon">
								<img src={`${process.env.PUBLIC_URL}/icons/search.png`} />
							</span>
							<input
								type="text"
								autoComplete="off"
								placeholder="POM code or name"
								value={search}
								onChange={(e) => {
									setSearch(e.target.value);
									setPage(0);
								}}
							/>
						</div>
					</div>
				</div>
				<div className="header-bottom pt-3 d-flex justify-content-between align-items-center align-self-center">
					<div className="sort-button">
						<select name="sort" id className="border-0" onChange={(e) => setSort(e.target.value)}>
							<option value={'parentCategory'} selected={sort === 'parentCategory'}>
								TBO
							</option>
							<option value={'bodyPart'} selected={sort === 'bodyPart'}>
								Body Parts
							</option>
							<option value={'position'} selected={sort === 'position'}>
								Position
							</option>
							<option value={'size'} selected={sort === 'size'}>
								POM Size
							</option>
							<option value={'side'} selected={sort === 'side'}>
								Side
							</option>
						</select>
					</div>
					{!pomTemplateDetails?.subCategoryResponse?.isPrimary &&
						fromPage !== 'MEASUREMENT' &&
						checkUserType('ADMIN') && (
							<div className="load-template" onClick={onLoadClick}>
								<p className="gray_dark_01 regular-14 cursor-pointer">
									Load POM from main category
								</p>
							</div>
						)}

					{fromPage === 'MEASUREMENT' && (
						<div className="load-template" onClick={onLoadPomTemplateClick}>
							<p
								className={`${
									isEditable() ? 'gray_dark_01' : 'gray_dark_03'
								}  regular-14 cursor-pointer`}
							>
								Load POM Template
							</p>
						</div>
					)}
				</div>
			</div>
			<div className="all-products scroll-y-label" ref={scrollRef} onScroll={handleScroll}>
				{allPomList?.data && <div className="data-table">{renderPomList()}</div>}
			</div>
		</div>
	);
};

export default AddPomFromRightPnael;
